import { applyKuulaBranding, type KuulaOverrides } from "@/lib/kuulaConfig";

const MOTION_PARAMS = ["gyro", "gyroscope", "accelerometer", "deviceorientation", "motion", "tilt"];
const MOBILE_BREAKPOINT = 768;

export function isMobileDevice(): boolean {
  if (typeof window === "undefined") return false;
  return window.innerWidth < MOBILE_BREAKPOINT;
}

export function withMotionDisabled(url: string): string {
  try {
    const parsed = new URL(url);
    MOTION_PARAMS.forEach((param) => parsed.searchParams.set(param, "0"));
    return parsed.toString();
  } catch {
    return url;
  }
}

export function withMotionEnabled(url: string): string {
  return withMotionDisabled(url);
}

export function buildTourUrl(url: string, _gyroEnabled = false, kuulaOverrides: KuulaOverrides = {}): string {
  return withMotionDisabled(applyKuulaBranding(url, kuulaOverrides));
}
